import { NumericBoolean } from '@bilibili-maoer/web-utils'

import { Outlet } from 'react-router-dom'
import { useMount } from 'react-use'

import { Box } from '@mui/material'
import { get } from 'lodash'

import { ReactComponent as NavFmImg } from '/assets/icons/user/center/nav-fm.svg'
import { ReactComponent as NavIncomeImg } from '/assets/icons/user/center/nav-income.svg'

import { useAppDispatch } from '~/app/hooks'
import { Sidebar } from '~/core/components/sidebar'
import { Routes } from '~/core/components/sidebar-nav'
import UiSlice from '~/core/slices/ui'
import { EAnnouncementType } from '~/features/announcements/types'
import { UserApi } from '~/services/fm/user'
import { NewsApi } from '~/services/web/news'

const getRoutes = (roomId?: number, notice?: NumericBoolean): Routes => [
  {
    icon: <NavFmImg />,
    text: '直播',
    children: [
      {
        to: '/user/center',
        text: '我的直播',
      },
      {
        to: '/user/center/follow',
        text: '我的关注',
      },
      {
        to: '/user/center/room',
        text: '房间管理',
        check: () => !!roomId && roomId > 0,
      },
      {
        to: '/user/center/ranking',
        text: '贡献榜',
        check: () => !!roomId && roomId > 0,
      },
      {
        to: '/user/center/withdraw-account',
        text: '提现账户信息',
      },
      {
        to: '/user/center/announcements',
        text: '公告',
        notice,
      },
    ],
  },
  {
    icon: <NavIncomeImg />,
    text: '素人相关',
    children: [
      {
        to: '/user/center/profit',
        text: '收益记录',
      },
      {
        to: '/user/center/withdraw',
        text: '收益提现',
      },
    ],
  },
  {
    icon: <NavIncomeImg />,
    text: '公会',
    children: [
      {
        to: '/user/center/mperson/guild', // TODO: 我的公会迁移完成后这里需改为 /user/center/guild
        text: '我的公会',
      },
      {
        to: '/user/center/guild-record',
        text: '邀请 / 申请记录',
      },
      {
        to: '/user/center/guild-profit',
        text: '公会收益',
      },
    ],
  },
]

export module CenterIndex {
  export const Layout = () => {
    const dispatch = useAppDispatch()

    useMount(() => {
      dispatch(UiSlice.actions.expandSidebar())
    })

    const { data } = UserApi.getUserInfo.useQuery()
    const { data: noticeData } = NewsApi.getNotice.useQuery({
      tag_ids: [EAnnouncementType.LiveGuildTag, EAnnouncementType.LiveLiverTag, EAnnouncementType.LiveTag],
    })
    const roomId = get(data, 'room.room_id')

    return (
      <Box sx={{ display: 'flex' }}>
        <Box sx={{ flex: 'none' }}>
          <Sidebar routes={getRoutes(roomId, noticeData?.data?.notices[EAnnouncementType.LiveLiverTag])} showUserInfo />
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Outlet />
        </Box>
      </Box>
    )
  }
}
